// extracted by mini-css-extract-plugin
export const loadingOverlay = "LoadingOverlay__loadingOverlay__oR6IS";
export const transparent = "LoadingOverlay__transparent__kyAWc";
export const asColumn = "LoadingOverlay__asColumn__z5VEG";